export default __webpack_public_path__ + "static/media/pb-img.0f2757a9.png";